import { OPEN_FILE_UPLOAD_WINDOW, REMOVE_FILE_FOR_UPLOAD, SAVE_FILE_FOR_UPLOAD } from '../constants';

/** @returns {{type: string}} */
export const openFileUploadWindow = () => ({ type: OPEN_FILE_UPLOAD_WINDOW });

/**
 * @param {{file: *}} payload
 * @returns {{payload: {file: *}, type: string}}
 */
export const saveFileForUpload = ({ file }) => ({
  type: SAVE_FILE_FOR_UPLOAD,
  payload: {
    file
  }
});

/**
 * @returns {{type: string}}
 */
export const removeFileForUpload = () => ({ type: REMOVE_FILE_FOR_UPLOAD });


